import app from 'flarum/forum/app';

export default function withLocaleKnowledgeBaseLink(routeName, params = {}) {
  // No multi-language knowledge base
  if (
    typeof flarum.extensions['fof-discussion-language'] === 'undefined' ||
    app.forum.attribute('support_knowledge_base_enable_language_dropdown') == false
  ) {
    return app.route(routeName, params);
  }

  // Use language link
  return app.route(routeName, {
    ...params,
    language: m.route.param().language,
    any: m.route.param().any === true ? true : undefined,
  });
}
